// Coordinates reducers
export type CoordinatesActionType =
  | "SET_COORD_X"
  | "SET_LAST_COORDS"
  | "SET_COORD_Y"
  | "APPEND_TO_LAST_COORDS"
  | "SET_FORMATTED_ADDRESS";

export type CoordinatesAction = {
  type: CoordinatesActionType;
  payload: number | [number, number] | [number, number][] | string;
};

export type CoordinatesData = {
  lastCoordY: number;
  lastCoordX: number;
  lastCoords: Array<[number, number]>;
  formattedAddress: string;
};

export const INITIAL_COORDS_STATE: CoordinatesData = {
  lastCoords: [],
  lastCoordX: 0,
  lastCoordY: 0,
  formattedAddress: ''
};

export function coordinatesReducer(
  state: CoordinatesData = INITIAL_COORDS_STATE,
  action: CoordinatesAction
): CoordinatesData {
  switch (action.type) {
    case "SET_COORD_X":
      if (typeof action.payload === "number") {
        return { ...state, lastCoordX: action.payload };
      }
      return { ...state };

    case "SET_COORD_Y":
      if (typeof action.payload === "number") {
        return { ...state, lastCoordY: action.payload };
      }
      return { ...state };

    case "SET_LAST_COORDS":
      if (Array.isArray(action.payload) && Array.isArray(action.payload[0])) {
        return {
          ...state,
          lastCoords: action.payload as [number, number][],
        };
      }
      return { ...state };
    case 'SET_FORMATTED_ADDRESS':
      if (typeof action.payload === 'string') {
        return { ...state, formattedAddress: action.payload };
      }

      return { ...state }
    case "APPEND_TO_LAST_COORDS":
      if (
        Array.isArray(action.payload) &&
        typeof action.payload[0] === "number"
      ) {
        return {
          ...state,
          lastCoords: [...state.lastCoords, action.payload] as [
            number,
            number
          ][],
        };
      }
      return { ...state };

    default:
      return state;
  }
}
